/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteReferralRecipientConfig200ResponseData
 */
export interface DeleteReferralRecipientConfig200ResponseData {
    /**
     * 
     */
    id: number;
}

/**
 * Check if a given object implements the DeleteReferralRecipientConfig200ResponseData interface.
 */
export function instanceOfDeleteReferralRecipientConfig200ResponseData(value: object): value is DeleteReferralRecipientConfig200ResponseData {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function DeleteReferralRecipientConfig200ResponseDataFromJSON(json: any): DeleteReferralRecipientConfig200ResponseData {
    return DeleteReferralRecipientConfig200ResponseDataFromJSONTyped(json, false);
}

export function DeleteReferralRecipientConfig200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteReferralRecipientConfig200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function DeleteReferralRecipientConfig200ResponseDataToJSON(json: any): DeleteReferralRecipientConfig200ResponseData {
    return DeleteReferralRecipientConfig200ResponseDataToJSONTyped(json, false);
}

export function DeleteReferralRecipientConfig200ResponseDataToJSONTyped(value?: DeleteReferralRecipientConfig200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

